import { onError, onAuthError } from 'mycorems-app-accounts';
import { notify } from 'mycorems-app-shared';
import { refreshAccessToken } from '@/authentication';

const excludeCodes = ['REFRESH_TOKEN.INVALID'];

onError((error) => {
  if (excludeCodes.includes(error.code)) return;
  const message = error.message || `The following error occurred: ${error.code}`;
  notify.failure(message);
});

onAuthError(refreshAccessToken);
